import './AdultAuth.sass';
import '../AuthPopover/AuthPopover.sass';
import '../CommonFeed/CommonFeed.sass';

import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Block, Button, Header, ScrollView } from '$uikit';
import { useTranslator } from '$hooks';
import { authSelector } from '$store/auth';
import { AuthPopoverSimple } from '$core/AuthPopover/AuthPopover';
import { profileActions } from '$store/profile';
import { AttachItem, AttachType, AuthPopoverState, CurrencyEnum } from '$store/models';
import { setSubscriptionContentPriority } from '$utils/subscriptionAuthor';
import { ContentPriorityType } from '$store/main/interface';
import { formatCurrency, statReachGoal } from '$utils';
import { useRoute, useRouter } from 'react-router5';
import { COMMON_FEED, SEARCH } from '$shared/constants/pages';
import { Api } from '$api';
import { mainSelector } from '$store/main';
import { MediaViewer, Slider } from '$shared/components';
import { PROMO_MODELS } from '$shared/constants';
import { IcPlay28 } from '$assets';

const PROMO_MODELS_FILTERED = PROMO_MODELS.filter((item) => item.promoPhoto);

const photosForSet1 = [
  require('../AuthPopover/assets/model1.png').default,
  require('../AuthPopover/assets/model2.png').default,
  require('../AuthPopover/assets/model3.png').default,
];

const photosForSet2 = [
  require('./assets/pic1.svg').default,
  require('./assets/pic2.svg').default,
  require('./assets/pic3.svg').default,
];

const photosForSet3 = [
  require('./assets/1.png').default,
  require('./assets/2.png').default,
  require('./assets/3.png').default,
];

const formatName = (string) => {
  const [firstName, lastName] = string.split(' ');
  return `${firstName} ${lastName ? lastName[0] + '.' : ''}`;
};

export const AdultAuth: React.FC = () => {
  const t = useTranslator();
  const { isLogged } = useSelector(authSelector);
  const dispatch = useDispatch();
  const router = useRouter();
  const { route } = useRoute();
  const showFeed = route.params ? !!route.params.show_feed : false;
  const showSearch = route.params ? !!route.params.show_search : false;
  const set = route.params ? +route.params.set : 1;
  const { subscriptionPrice, subscriptionRubPrice } = useSelector(mainSelector);
  const [viewPhotoIndex, setViewPhotoIndex] = useState<number | null>(null);

  const [price, setPrice] = useState({
    ton: subscriptionPrice,
    eur: subscriptionRubPrice,
  });

  const loadPrice = useCallback(() => {
    Api.get(`/balance/subscription/common/adult`)
      .then((data: any) => {
        setPrice({
          ton: data.price,
          eur: data.eurPrice,
        });
      })
      .catch(() => {
        setTimeout(() => loadPrice(), 5000);
      });
  }, []);

  useEffect(() => {
    loadPrice();
  }, []);

  const data = useMemo(() => {
    if (set === 2) {
      return {
        photos: photosForSet2,
        title: 'Talk to real models',
        caption: '',
        features: [
          t('adult_auth_feature2'),
          t('adult_auth_feature1_set2'),
          t('adult_auth_feature3_set2'),
          t('adult_auth_feature4'),
          t('adult_auth_feature5_set2'),
          t('adult_auth_feature6'),
        ],
      };
    } else if (set === 3) {
      return {
        photos: photosForSet3,
        title: 'Talk to real models',
        caption: '',
        features: [
          t('adult_auth_feature2'),
          t('adult_auth_feature1_set2'),
          t('adult_auth_feature3_set2'),
          t('adult_auth_feature4'),
          t('adult_auth_feature5_set2'),
          t('adult_auth_feature6'),
        ],
      };
    } else {
      return {
        photos: photosForSet1,
        title: t('adult_auth__title'),
        caption: t('adult_auth__caption'),
        features: [
          t('adult_auth_feature1'),
          t('adult_auth_feature2'),
          t('adult_auth_feature3'),
          t('adult_auth_feature4'),
          t('adult_auth_feature5'),
          t('adult_auth_feature6'),
        ],
      };
    }
  }, [set]);

  useEffect(() => {
    if (isLogged) {
      //window.location.href = '/subscription/adult';
    } else {
      setSubscriptionContentPriority(ContentPriorityType.ADULT);
    }

    statReachGoal('landing_adult_auth_open');
    if (showFeed) {
      statReachGoal('landing_adult_auth_feed');
    } else if (showSearch) {
      statReachGoal('landing_adult_auth_search');
    }
  }, []);

  const signInHandle = useCallback(() => {
    if (isLogged) {
      window.location.href = '/subscription/adult';
    } else if (showFeed) {
      router.navigate(COMMON_FEED);
    } else if (showSearch) {
      router.navigate(SEARCH);
    } else {
      dispatch(profileActions.setAuthPopoverState(AuthPopoverState.REGISTER));
    }
    statReachGoal('landing_adult_auth_btn_press');
  }, [showFeed, showSearch, isLogged]);

  const attachments = useMemo(() => {
    return PROMO_MODELS_FILTERED.map((item, index) => {
      return {
        type: AttachType.PHOTO,
        photo: {
          photoId: index + 1,
          photoLarge: item.promoPhoto,
          photoMedium: item.promoPhoto,
          width: item.promoPhotoWidth || item.width,
          height: item.promoPhotoHeight || item.height,
        },
      };
    }) as AttachItem[];
  }, [PROMO_MODELS]);

  return (
    <>
      <Header>Ton.Place</Header>
      <ScrollView
        footer={
          <Button flare onClick={signInHandle}>
            {t('adult_auth_btn_old')}
          </Button>
        }
      >
        <div className="VerificationLanding__title">
          Better than <strong>OnlyFans</strong>
        </div>
        <div className="VerificationLanding__subTitle">
          Thousands of beautiful girls from Ukraine, Russia and Belarus are waiting for
          you.
        </div>
        <Block className="VerificationLanding__modelBlock">
          <div className="VerificationLanding__modelBlock__title">Our girls</div>
          <div className="VerificationLanding__modelBlock__desc">
            Check out our girls and choose the one you like.
          </div>
          {viewPhotoIndex !== null && ( // Hack for offline (unsigned) users
            <MediaViewer
              decryptKey={''}
              active={true}
              startFrom={viewPhotoIndex}
              attachments={attachments}
              onClose={() => setViewPhotoIndex(null)}
            />
          )}
          <Slider className="VerificationLanding__models">
            {PROMO_MODELS_FILTERED.map((item, index) => (
              <div key={item.avatar} className="VerificationLanding__model">
                <div
                  className="VerificationLanding__model__image"
                  onClick={() => setViewPhotoIndex(index)}
                  style={{ backgroundImage: `url(${item.promoPhoto})` }}
                />
                <a
                  href={'https://ton.place/' + (item.domain || `id${item.id}`)}
                  className="VerificationLanding__model__platform"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="VerificationLanding__model__icon" />
                  {formatName(item.name)}
                </a>
                <a
                  href={'https://instagram.com/' + item.instagram}
                  className="VerificationLanding__model__instagram"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="VerificationLanding__model__icon" />
                  {item.instagramCount}
                </a>
              </div>
            ))}
          </Slider>
        </Block>
        <div className="AdultAuth__features">
          {data.features.map((feature, index) => (
            <div className="AdultAuth__feature" key={index}>
              {feature}
            </div>
          ))}
        </div>
      </ScrollView>
      <AuthPopoverSimple />
    </>
  );
};
